import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
class JobDetailMenuItem extends Component {
    render() {
        const { menuItem: { name, iconClassName, active, visible, sectionKey, }, } = this.props;
        const menuItemClassName = classnames({
            job_details__menu__item: true,
            'job_details__menu__item--active': active,
        });
        const finalIconClassName = classnames({
            fa: true,
            [iconClassName]: true,
            'fa-2x': true,
            job_details__menu__icon: true,
        });
        if (!visible) {
            return null;
        }
        return (React.createElement("div", { className: menuItemClassName, onClick: () => this.props.onSelectMenuItem(sectionKey) },
            React.createElement("i", { className: finalIconClassName, alt: name }),
            name));
    }
}
JobDetailMenuItem.propTypes = {
    menuItem: PropTypes.shape({
        name: PropTypes.string.isRequired,
        sectionKey: PropTypes.string.isRequired,
        active: PropTypes.bool.isRequired,
        visible: PropTypes.bool.isRequired,
        iconClassName: PropTypes.string.isRequired,
    }).isRequired,
    onSelectMenuItem: PropTypes.func.isRequired,
};
JobDetailMenuItem.defaultProps = {
    enabled: true,
    active: false,
};
export default JobDetailMenuItem;
